import { api } from './api';
export const addTagTypes = [
  'widget',
  'auth',
  'user',
  'organization',
  'channel',
  'agent',
  'dialog',
  'client',
  'integration',
  'analytics',
  'knowledge',
  'team',
  'credit',
  'agent_test',
  'backup',
  'widget_settings',
  'iframe',
  'preview',
  'asyncapi',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      sendMessageWidgetMessagePost: build.mutation<
        SendMessageWidgetMessagePostApiResponse,
        SendMessageWidgetMessagePostApiArg
      >({
        query: (queryArg) => ({
          url: `/widget/message`,
          method: 'POST',
          body: queryArg.bodySendMessageWidgetMessagePost,
        }),
        invalidatesTags: ['widget'],
      }),
      getChatHistoryWidgetChatHistoryGet: build.query<
        GetChatHistoryWidgetChatHistoryGetApiResponse,
        GetChatHistoryWidgetChatHistoryGetApiArg
      >({
        query: (queryArg) => ({
          url: `/widget/chat_history`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ['widget'],
      }),
      sendClientFieldsWidgetFieldsPost: build.mutation<
        SendClientFieldsWidgetFieldsPostApiResponse,
        SendClientFieldsWidgetFieldsPostApiArg
      >({
        query: (queryArg) => ({
          url: `/widget/fields`,
          method: 'POST',
          body: queryArg.bodySendClientFieldsWidgetFieldsPost,
        }),
        invalidatesTags: ['widget'],
      }),
      sendClientFieldsByAliasWidgetFieldsByAliasPost: build.mutation<
        SendClientFieldsByAliasWidgetFieldsByAliasPostApiResponse,
        SendClientFieldsByAliasWidgetFieldsByAliasPostApiArg
      >({
        query: (queryArg) => ({
          url: `/widget/fields_by_alias`,
          method: 'POST',
          body: queryArg.bodySendClientFieldsByAliasWidgetFieldsByAliasPost,
        }),
        invalidatesTags: ['widget'],
      }),
      getWidgetPreviewWidgetPreviewGet: build.query<
        GetWidgetPreviewWidgetPreviewGetApiResponse,
        GetWidgetPreviewWidgetPreviewGetApiArg
      >({
        query: (queryArg) => ({
          url: `/widget/preview`,
          params: {
            url: queryArg.url,
          },
        }),
        providesTags: ['widget'],
      }),
      getWidgetScriptWidgetScriptJsGet: build.query<
        GetWidgetScriptWidgetScriptJsGetApiResponse,
        GetWidgetScriptWidgetScriptJsGetApiArg
      >({
        query: () => ({ url: `/widget/script.js` }),
        providesTags: ['widget'],
      }),
      getWidgetSettingsWidgetSettingsGet: build.query<
        GetWidgetSettingsWidgetSettingsGetApiResponse,
        GetWidgetSettingsWidgetSettingsGetApiArg
      >({
        query: () => ({ url: `/widget/settings` }),
        providesTags: ['widget'],
      }),
      sendEventWidgetEventPost: build.mutation<
        SendEventWidgetEventPostApiResponse,
        SendEventWidgetEventPostApiArg
      >({
        query: (queryArg) => ({
          url: `/widget/event`,
          method: 'POST',
          body: queryArg.bodySendEventWidgetEventPost,
        }),
        invalidatesTags: ['widget'],
      }),
      authByTokenAuthProviderProviderTypePost: build.mutation<
        AuthByTokenAuthProviderProviderTypePostApiResponse,
        AuthByTokenAuthProviderProviderTypePostApiArg
      >({
        query: (queryArg) => ({
          url: `/auth/provider/${queryArg.providerType}`,
          method: 'POST',
          body: queryArg.bodyAuthByTokenAuthProviderProviderTypePost,
        }),
        invalidatesTags: ['auth'],
      }),
      refreshTokenAuthTokenRefreshPost: build.mutation<
        RefreshTokenAuthTokenRefreshPostApiResponse,
        RefreshTokenAuthTokenRefreshPostApiArg
      >({
        query: (queryArg) => ({
          url: `/auth/token/refresh`,
          method: 'POST',
          body: queryArg.bodyRefreshTokenAuthTokenRefreshPost,
        }),
        invalidatesTags: ['auth'],
      }),
      getMeUserMeGet: build.query<GetMeUserMeGetApiResponse, GetMeUserMeGetApiArg>({
        query: () => ({ url: `/user/me` }),
        providesTags: ['user'],
      }),
      getOrganizationListOrganizationListGet: build.query<
        GetOrganizationListOrganizationListGetApiResponse,
        GetOrganizationListOrganizationListGetApiArg
      >({
        query: () => ({ url: `/organization/list` }),
        providesTags: ['organization'],
      }),
      createOrganizationOrganizationCreatePost: build.mutation<
        CreateOrganizationOrganizationCreatePostApiResponse,
        CreateOrganizationOrganizationCreatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/create`,
          method: 'POST',
          body: queryArg.createOrganization,
        }),
        invalidatesTags: ['organization'],
      }),
      changeNameOrganizationOrganizationChangeNamePost: build.mutation<
        ChangeNameOrganizationOrganizationChangeNamePostApiResponse,
        ChangeNameOrganizationOrganizationChangeNamePostApiArg
      >({
        query: (queryArg) => ({
          url: `/organization/change_name`,
          method: 'POST',
          body: queryArg.bodyChangeNameOrganizationOrganizationChangeNamePost,
        }),
        invalidatesTags: ['organization'],
      }),
      getChannelListChannelListGet: build.query<
        GetChannelListChannelListGetApiResponse,
        GetChannelListChannelListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/list`,
          params: {
            organization_id: queryArg.organizationId,
            agent_id: queryArg.agentId,
          },
        }),
        providesTags: ['channel'],
      }),
      getChannelInfoChannelInfoGet: build.query<
        GetChannelInfoChannelInfoGetApiResponse,
        GetChannelInfoChannelInfoGetApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/info`,
          params: {
            channel_id: queryArg.channelId,
          },
        }),
        providesTags: ['channel'],
      }),
      createTelegramBotChannelChannelCreateTelegramBotPost: build.mutation<
        CreateTelegramBotChannelChannelCreateTelegramBotPostApiResponse,
        CreateTelegramBotChannelChannelCreateTelegramBotPostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/create/telegram_bot`,
          method: 'POST',
          body: queryArg.createTelegramBotChannel,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      createVkBotChannelChannelCreateVkBotPost: build.mutation<
        CreateVkBotChannelChannelCreateVkBotPostApiResponse,
        CreateVkBotChannelChannelCreateVkBotPostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/create/vk_bot`,
          method: 'POST',
          body: queryArg.createVkBotChannel,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      createWidgetChannelChannelCreateWidgetPost: build.mutation<
        CreateWidgetChannelChannelCreateWidgetPostApiResponse,
        CreateWidgetChannelChannelCreateWidgetPostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/create/widget`,
          method: 'POST',
          body: queryArg.createWidgetChannel,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      createWidgetChannelChannelCreateAlisaPost: build.mutation<
        CreateWidgetChannelChannelCreateAlisaPostApiResponse,
        CreateWidgetChannelChannelCreateAlisaPostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/create/alisa`,
          method: 'POST',
          body: queryArg.createAlisaChannel,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      createTelegramChannelChannelCreateTelegramPost: build.mutation<
        CreateTelegramChannelChannelCreateTelegramPostApiResponse,
        CreateTelegramChannelChannelCreateTelegramPostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/create/telegram`,
          method: 'POST',
          body: queryArg.createChannel,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      createAvitoChannelChannelCreateAvitoPost: build.mutation<
        CreateAvitoChannelChannelCreateAvitoPostApiResponse,
        CreateAvitoChannelChannelCreateAvitoPostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/create/avito`,
          method: 'POST',
          body: queryArg.createAvitoChannel,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      createMaxBotChannelChannelCreateMaxBotPost: build.mutation<
        CreateMaxBotChannelChannelCreateMaxBotPostApiResponse,
        CreateMaxBotChannelChannelCreateMaxBotPostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/create/max_bot`,
          method: 'POST',
          body: queryArg.createMaxBotChannel,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      updateChannelChannelUpdatePost: build.mutation<
        UpdateChannelChannelUpdatePostApiResponse,
        UpdateChannelChannelUpdatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/update`,
          method: 'POST',
          body: queryArg.updateChannel,
          params: {
            channel_id: queryArg.channelId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      channelHealthCheckChannelHealthPost: build.mutation<
        ChannelHealthCheckChannelHealthPostApiResponse,
        ChannelHealthCheckChannelHealthPostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/health`,
          method: 'POST',
          params: {
            channel_id: queryArg.channelId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      deleteChannelChannelDeleteDelete: build.mutation<
        DeleteChannelChannelDeleteDeleteApiResponse,
        DeleteChannelChannelDeleteDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/delete`,
          method: 'DELETE',
          params: {
            channel_id: queryArg.channelId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      getTelegramQrLinkChannelTelegramQrLinkPost: build.mutation<
        GetTelegramQrLinkChannelTelegramQrLinkPostApiResponse,
        GetTelegramQrLinkChannelTelegramQrLinkPostApiArg
      >({
        query: (queryArg) => ({
          url: `/channel/telegram/qr_link`,
          method: 'POST',
          params: {
            channel_id: queryArg.channelId,
          },
        }),
        invalidatesTags: ['channel'],
      }),
      getAgentInfoAgentInfoGet: build.query<
        GetAgentInfoAgentInfoGetApiResponse,
        GetAgentInfoAgentInfoGetApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/info`,
          params: {
            agent_id: queryArg.agentId,
          },
        }),
        providesTags: ['agent'],
      }),
      getAgentListAgentListGet: build.query<
        GetAgentListAgentListGetApiResponse,
        GetAgentListAgentListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/list`,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        providesTags: ['agent'],
      }),
      createAgentAgentCreatePost: build.mutation<
        CreateAgentAgentCreatePostApiResponse,
        CreateAgentAgentCreatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/create`,
          method: 'POST',
          body: queryArg.createAgentData,
          headers: {
            'x-language': queryArg['x-language'],
          },
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        invalidatesTags: ['agent'],
      }),
      updateAgentAgentUpdatePost: build.mutation<
        UpdateAgentAgentUpdatePostApiResponse,
        UpdateAgentAgentUpdatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/update`,
          method: 'POST',
          body: queryArg.updateAgentData,
          params: {
            agent_id: queryArg.agentId,
          },
        }),
        invalidatesTags: ['agent'],
      }),
      deleteAgentAgentDeleteDelete: build.mutation<
        DeleteAgentAgentDeleteDeleteApiResponse,
        DeleteAgentAgentDeleteDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/delete`,
          method: 'DELETE',
          params: {
            agent_id: queryArg.agentId,
          },
        }),
        invalidatesTags: ['agent'],
      }),
      agentFieldAgentFieldGet: build.query<
        AgentFieldAgentFieldGetApiResponse,
        AgentFieldAgentFieldGetApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/field`,
          params: {
            agent_field_id: queryArg.agentFieldId,
          },
        }),
        providesTags: ['agent'],
      }),
      agentFieldDeleteAgentFieldDelete: build.mutation<
        AgentFieldDeleteAgentFieldDeleteApiResponse,
        AgentFieldDeleteAgentFieldDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/field`,
          method: 'DELETE',
          params: {
            agent_field_id: queryArg.agentFieldId,
          },
        }),
        invalidatesTags: ['agent'],
      }),
      agentFieldsListAgentFieldListGet: build.query<
        AgentFieldsListAgentFieldListGetApiResponse,
        AgentFieldsListAgentFieldListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/field/list`,
          params: {
            agent_id: queryArg.agentId,
          },
        }),
        providesTags: ['agent'],
      }),
      agentFieldCreateAgentFieldCreatePost: build.mutation<
        AgentFieldCreateAgentFieldCreatePostApiResponse,
        AgentFieldCreateAgentFieldCreatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/field/create`,
          method: 'POST',
          body: queryArg.createAgentField,
          params: {
            agent_id: queryArg.agentId,
          },
        }),
        invalidatesTags: ['agent'],
      }),
      agentFieldUpdateAgentFieldUpdatePost: build.mutation<
        AgentFieldUpdateAgentFieldUpdatePostApiResponse,
        AgentFieldUpdateAgentFieldUpdatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/agent/field/update`,
          method: 'POST',
          body: queryArg.updateAgentField,
          params: {
            agent_field_id: queryArg.agentFieldId,
          },
        }),
        invalidatesTags: ['agent'],
      }),
      getDialogHistoryDialogHistoryGet: build.query<
        GetDialogHistoryDialogHistoryGetApiResponse,
        GetDialogHistoryDialogHistoryGetApiArg
      >({
        query: (queryArg) => ({
          url: `/dialog/history`,
          params: {
            client_id: queryArg.clientId,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ['dialog'],
      }),
      getListDialogsDialogListPost: build.mutation<
        GetListDialogsDialogListPostApiResponse,
        GetListDialogsDialogListPostApiArg
      >({
        query: (queryArg) => ({
          url: `/dialog/list`,
          method: 'POST',
          body: queryArg.dialogListFilters,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        invalidatesTags: ['dialog'],
      }),
      sendDialogMessageDialogSendPost: build.mutation<
        SendDialogMessageDialogSendPostApiResponse,
        SendDialogMessageDialogSendPostApiArg
      >({
        query: (queryArg) => ({
          url: `/dialog/send`,
          method: 'POST',
          body: queryArg.bodySendDialogMessageDialogSendPost,
        }),
        invalidatesTags: ['dialog'],
      }),
      addManagerDeltaTimeDialogAddManagerDeltaTimePost: build.mutation<
        AddManagerDeltaTimeDialogAddManagerDeltaTimePostApiResponse,
        AddManagerDeltaTimeDialogAddManagerDeltaTimePostApiArg
      >({
        query: (queryArg) => ({
          url: `/dialog/add_manager_delta_time`,
          method: 'POST',
          body: queryArg.bodyAddManagerDeltaTimeDialogAddManagerDeltaTimePost,
        }),
        invalidatesTags: ['dialog'],
      }),
      getLastManagerMessageDialogGetLastManagerMessagePost: build.mutation<
        GetLastManagerMessageDialogGetLastManagerMessagePostApiResponse,
        GetLastManagerMessageDialogGetLastManagerMessagePostApiArg
      >({
        query: (queryArg) => ({
          url: `/dialog/get_last_manager_message`,
          method: 'POST',
          body: queryArg.bodyGetLastManagerMessageDialogGetLastManagerMessagePost,
        }),
        invalidatesTags: ['dialog'],
      }),
      getClientFieldsClientFieldsGet: build.query<
        GetClientFieldsClientFieldsGetApiResponse,
        GetClientFieldsClientFieldsGetApiArg
      >({
        query: (queryArg) => ({
          url: `/client/fields`,
          params: {
            client_id: queryArg.clientId,
          },
        }),
        providesTags: ['client'],
      }),
      updateClientFieldsClientFieldsUpdatePost: build.mutation<
        UpdateClientFieldsClientFieldsUpdatePostApiResponse,
        UpdateClientFieldsClientFieldsUpdatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/client/fields/update`,
          method: 'POST',
          body: queryArg.updateClientFieldData,
        }),
        invalidatesTags: ['client'],
      }),
      resendLeadClientLeadResendPost: build.mutation<
        ResendLeadClientLeadResendPostApiResponse,
        ResendLeadClientLeadResendPostApiArg
      >({
        query: (queryArg) => ({
          url: `/client/lead/resend`,
          method: 'POST',
          params: {
            client_id: queryArg.clientId,
          },
        }),
        invalidatesTags: ['client'],
      }),
      updateClientTestClientUpdateTestPost: build.mutation<
        UpdateClientTestClientUpdateTestPostApiResponse,
        UpdateClientTestClientUpdateTestPostApiArg
      >({
        query: (queryArg) => ({
          url: `/client/update_test`,
          method: 'POST',
          body: queryArg.updateClientTestData,
        }),
        invalidatesTags: ['client'],
      }),
      webhookListIntegrationWebhookListGet: build.query<
        WebhookListIntegrationWebhookListGetApiResponse,
        WebhookListIntegrationWebhookListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/integration/webhook/list`,
          params: {
            channel_id: queryArg.channelId,
          },
        }),
        providesTags: ['integration'],
      }),
      webhookInfoIntegrationWebhookInfoGet: build.query<
        WebhookInfoIntegrationWebhookInfoGetApiResponse,
        WebhookInfoIntegrationWebhookInfoGetApiArg
      >({
        query: (queryArg) => ({
          url: `/integration/webhook/info`,
          params: {
            webhook_integration_id: queryArg.webhookIntegrationId,
          },
        }),
        providesTags: ['integration'],
      }),
      webhookCreateIntegrationWebhookCreatePost: build.mutation<
        WebhookCreateIntegrationWebhookCreatePostApiResponse,
        WebhookCreateIntegrationWebhookCreatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/integration/webhook/create`,
          method: 'POST',
          body: queryArg.webhookIntegrationCreate,
        }),
        invalidatesTags: ['integration'],
      }),
      webhookDeleteIntegrationWebhookDeleteDelete: build.mutation<
        WebhookDeleteIntegrationWebhookDeleteDeleteApiResponse,
        WebhookDeleteIntegrationWebhookDeleteDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/integration/webhook/delete`,
          method: 'DELETE',
          params: {
            webhook_integration_id: queryArg.webhookIntegrationId,
          },
        }),
        invalidatesTags: ['integration'],
      }),
      webhookUpdateIntegrationWebhookUpdatePost: build.mutation<
        WebhookUpdateIntegrationWebhookUpdatePostApiResponse,
        WebhookUpdateIntegrationWebhookUpdatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/integration/webhook/update`,
          method: 'POST',
          body: queryArg.webhookIntegrationUpdate,
          params: {
            webhook_integration_id: queryArg.webhookIntegrationId,
          },
        }),
        invalidatesTags: ['integration'],
      }),
      webhookFieldCreateIntegrationWebhookFieldCreatePost: build.mutation<
        WebhookFieldCreateIntegrationWebhookFieldCreatePostApiResponse,
        WebhookFieldCreateIntegrationWebhookFieldCreatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/integration/webhook/field/create`,
          method: 'POST',
          body: queryArg.webhookIntegrationFieldCreate,
          params: {
            webhook_integration_id: queryArg.webhookIntegrationId,
          },
        }),
        invalidatesTags: ['integration'],
      }),
      webhookFieldDeleteIntegrationWebhookFieldDelete: build.mutation<
        WebhookFieldDeleteIntegrationWebhookFieldDeleteApiResponse,
        WebhookFieldDeleteIntegrationWebhookFieldDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/integration/webhook/field`,
          method: 'DELETE',
          params: {
            webhook_integration_field_id: queryArg.webhookIntegrationFieldId,
          },
        }),
        invalidatesTags: ['integration'],
      }),
      getClientsStatsAnalyticsStatsClientsPost: build.mutation<
        GetClientsStatsAnalyticsStatsClientsPostApiResponse,
        GetClientsStatsAnalyticsStatsClientsPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/stats/clients`,
          method: 'POST',
          body: queryArg.analyticsDialogsRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getMessagesStatsAnalyticsStatsMessagesPost: build.mutation<
        GetMessagesStatsAnalyticsStatsMessagesPostApiResponse,
        GetMessagesStatsAnalyticsStatsMessagesPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/stats/messages`,
          method: 'POST',
          body: queryArg.analyticsDialogsRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getLeadsStatsAnalyticsStatsLeadsPost: build.mutation<
        GetLeadsStatsAnalyticsStatsLeadsPostApiResponse,
        GetLeadsStatsAnalyticsStatsLeadsPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/stats/leads`,
          method: 'POST',
          body: queryArg.analyticsDialogsRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getDialogsStatsAnalyticsStatsDialogsPost: build.mutation<
        GetDialogsStatsAnalyticsStatsDialogsPostApiResponse,
        GetDialogsStatsAnalyticsStatsDialogsPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/stats/dialogs`,
          method: 'POST',
          body: queryArg.analyticsDialogsRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getAllStatsAnalyticsStatsAllPost: build.mutation<
        GetAllStatsAnalyticsStatsAllPostApiResponse,
        GetAllStatsAnalyticsStatsAllPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/stats/all`,
          method: 'POST',
          body: queryArg.analyticsDialogsRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getExpensesStatsAnalyticsStatsExpensesPost: build.mutation<
        GetExpensesStatsAnalyticsStatsExpensesPostApiResponse,
        GetExpensesStatsAnalyticsStatsExpensesPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/stats/expenses`,
          method: 'POST',
          body: queryArg.analyticsDialogsRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getQuestionsStatsAnalyticsStatsQuestionsPost: build.mutation<
        GetQuestionsStatsAnalyticsStatsQuestionsPostApiResponse,
        GetQuestionsStatsAnalyticsStatsQuestionsPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/stats/questions`,
          method: 'POST',
          body: queryArg.analyticsDialogsRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getAllStatsWidgetAnalyticsWidgetStatsPost: build.mutation<
        GetAllStatsWidgetAnalyticsWidgetStatsPostApiResponse,
        GetAllStatsWidgetAnalyticsWidgetStatsPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/widget/stats`,
          method: 'POST',
          body: queryArg.analyticsWidgetStatsRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getWidgetPagesAnalyticsWidgetPagesPost: build.mutation<
        GetWidgetPagesAnalyticsWidgetPagesPostApiResponse,
        GetWidgetPagesAnalyticsWidgetPagesPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/widget/pages`,
          method: 'POST',
          body: queryArg.analyticsWidgetPagesRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getWidgetPageMessagesAnalyticsWidgetPagesMessagesPost: build.mutation<
        GetWidgetPageMessagesAnalyticsWidgetPagesMessagesPostApiResponse,
        GetWidgetPageMessagesAnalyticsWidgetPagesMessagesPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/widget/pages/messages`,
          method: 'POST',
          body: queryArg.analyticsWidgetPageMessagesRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getWidgetChangesAnalyticsWidgetChangesPost: build.mutation<
        GetWidgetChangesAnalyticsWidgetChangesPostApiResponse,
        GetWidgetChangesAnalyticsWidgetChangesPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/widget/changes`,
          method: 'POST',
          body: queryArg.widgetChangesRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getWidgetChangesDetailsAnalyticsWidgetChangesDetailsPost: build.mutation<
        GetWidgetChangesDetailsAnalyticsWidgetChangesDetailsPostApiResponse,
        GetWidgetChangesDetailsAnalyticsWidgetChangesDetailsPostApiArg
      >({
        query: (queryArg) => ({
          url: `/analytics/widget/changes/details`,
          method: 'POST',
          body: queryArg.widgetChangesDetailsRequest,
        }),
        invalidatesTags: ['analytics'],
      }),
      getKnowledgeListKnowledgeListGet: build.query<
        GetKnowledgeListKnowledgeListGetApiResponse,
        GetKnowledgeListKnowledgeListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/list`,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        providesTags: ['knowledge'],
      }),
      knowledgeLinkAddKnowledgeLinkAddPost: build.mutation<
        KnowledgeLinkAddKnowledgeLinkAddPostApiResponse,
        KnowledgeLinkAddKnowledgeLinkAddPostApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/link/add`,
          method: 'POST',
          body: queryArg.bodyKnowledgeLinkAddKnowledgeLinkAddPost,
        }),
        invalidatesTags: ['knowledge'],
      }),
      knowledgeLinkRelatedKnowledgeLinkRelatedPost: build.mutation<
        KnowledgeLinkRelatedKnowledgeLinkRelatedPostApiResponse,
        KnowledgeLinkRelatedKnowledgeLinkRelatedPostApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/link/related`,
          method: 'POST',
          body: queryArg.bodyKnowledgeLinkRelatedKnowledgeLinkRelatedPost,
        }),
        invalidatesTags: ['knowledge'],
      }),
      knowledgeFileUploadKnowledgeFileUploadPost: build.mutation<
        KnowledgeFileUploadKnowledgeFileUploadPostApiResponse,
        KnowledgeFileUploadKnowledgeFileUploadPostApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/file/upload`,
          method: 'POST',
          body: queryArg.bodyKnowledgeFileUploadKnowledgeFileUploadPost,
        }),
        invalidatesTags: ['knowledge'],
      }),
      knowledgeFileDownloadKnowledgeFileDownloadGet: build.query<
        KnowledgeFileDownloadKnowledgeFileDownloadGetApiResponse,
        KnowledgeFileDownloadKnowledgeFileDownloadGetApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/file/download`,
          params: {
            knowledge_base_id: queryArg.knowledgeBaseId,
          },
        }),
        providesTags: ['knowledge'],
      }),
      knowledgeBaseDeleteKnowledgeRemoveDelete: build.mutation<
        KnowledgeBaseDeleteKnowledgeRemoveDeleteApiResponse,
        KnowledgeBaseDeleteKnowledgeRemoveDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/remove`,
          method: 'DELETE',
          params: {
            knowledge_base_id: queryArg.knowledgeBaseId,
          },
        }),
        invalidatesTags: ['knowledge'],
      }),
      knowledgeBaseUpdateKnowledgeAgentUpdatePost: build.mutation<
        KnowledgeBaseUpdateKnowledgeAgentUpdatePostApiResponse,
        KnowledgeBaseUpdateKnowledgeAgentUpdatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/agent/update`,
          method: 'POST',
          body: queryArg.bodyKnowledgeBaseUpdateKnowledgeAgentUpdatePost,
        }),
        invalidatesTags: ['knowledge'],
      }),
      knowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPost: build.mutation<
        KnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPostApiResponse,
        KnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPostApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/linked_document/upload`,
          method: 'POST',
          body: queryArg.bodyKnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPost,
        }),
        invalidatesTags: ['knowledge'],
      }),
      knowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePost: build.mutation<
        KnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePostApiResponse,
        KnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/sync_period_update`,
          method: 'POST',
          body: queryArg.bodyKnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePost,
        }),
        invalidatesTags: ['knowledge'],
      }),
      knowledgeManualSyncKnowledgeLinkedDocumentSyncPost: build.mutation<
        KnowledgeManualSyncKnowledgeLinkedDocumentSyncPostApiResponse,
        KnowledgeManualSyncKnowledgeLinkedDocumentSyncPostApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge/linked_document/sync`,
          method: 'POST',
          body: queryArg.bodyKnowledgeManualSyncKnowledgeLinkedDocumentSyncPost,
        }),
        invalidatesTags: ['knowledge'],
      }),
      membersListTeamListGet: build.query<
        MembersListTeamListGetApiResponse,
        MembersListTeamListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/team/list`,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        providesTags: ['team'],
      }),
      updatePermissionTeamUpdatePermissionPost: build.mutation<
        UpdatePermissionTeamUpdatePermissionPostApiResponse,
        UpdatePermissionTeamUpdatePermissionPostApiArg
      >({
        query: (queryArg) => ({
          url: `/team/update/permission`,
          method: 'POST',
          body: queryArg.bodyUpdatePermissionTeamUpdatePermissionPost,
        }),
        invalidatesTags: ['team'],
      }),
      removeMemberTeamRemoveDelete: build.mutation<
        RemoveMemberTeamRemoveDeleteApiResponse,
        RemoveMemberTeamRemoveDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/team/remove`,
          method: 'DELETE',
          body: queryArg.bodyRemoveMemberTeamRemoveDelete,
        }),
        invalidatesTags: ['team'],
      }),
      createInviteLinkTeamCreateInviteLinkGet: build.query<
        CreateInviteLinkTeamCreateInviteLinkGetApiResponse,
        CreateInviteLinkTeamCreateInviteLinkGetApiArg
      >({
        query: (queryArg) => ({
          url: `/team/create_invite_link`,
          params: {
            organization_id: queryArg.organizationId,
            role: queryArg.role,
          },
        }),
        providesTags: ['team'],
      }),
      createInviteLinkTeamJoinPost: build.mutation<
        CreateInviteLinkTeamJoinPostApiResponse,
        CreateInviteLinkTeamJoinPostApiArg
      >({
        query: (queryArg) => ({
          url: `/team/join`,
          method: 'POST',
          body: queryArg.bodyCreateInviteLinkTeamJoinPost,
        }),
        invalidatesTags: ['team'],
      }),
      getTransactionsListCreditTransactionsListPost: build.mutation<
        GetTransactionsListCreditTransactionsListPostApiResponse,
        GetTransactionsListCreditTransactionsListPostApiArg
      >({
        query: (queryArg) => ({
          url: `/credit/transactions/list`,
          method: 'POST',
          body: queryArg.transactionsListFilters,
          params: {
            organization_id: queryArg.organizationId,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        invalidatesTags: ['credit'],
      }),
      getMessageListAgentTestListGet: build.query<
        GetMessageListAgentTestListGetApiResponse,
        GetMessageListAgentTestListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/agent_test/list`,
          params: {
            agent_id: queryArg.agentId,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ['agent_test'],
      }),
      sendAgentMessageAgentTestMessagePost: build.mutation<
        SendAgentMessageAgentTestMessagePostApiResponse,
        SendAgentMessageAgentTestMessagePostApiArg
      >({
        query: (queryArg) => ({
          url: `/agent_test/message`,
          method: 'POST',
          body: queryArg.bodySendAgentMessageAgentTestMessagePost,
          params: {
            agent_id: queryArg.agentId,
          },
        }),
        invalidatesTags: ['agent_test'],
      }),
      clearHistoryAgentTestClearHistoryPost: build.mutation<
        ClearHistoryAgentTestClearHistoryPostApiResponse,
        ClearHistoryAgentTestClearHistoryPostApiArg
      >({
        query: (queryArg) => ({
          url: `/agent_test/clear_history`,
          method: 'POST',
          params: {
            agent_id: queryArg.agentId,
          },
        }),
        invalidatesTags: ['agent_test'],
      }),
      getUserAgentFieldsAgentTestFieldsValuesGet: build.query<
        GetUserAgentFieldsAgentTestFieldsValuesGetApiResponse,
        GetUserAgentFieldsAgentTestFieldsValuesGetApiArg
      >({
        query: (queryArg) => ({
          url: `/agent_test/fields_values`,
          params: {
            agent_id: queryArg.agentId,
          },
        }),
        providesTags: ['agent_test'],
      }),
      alisaMessageRequestAlisaMessagePost: build.mutation<
        AlisaMessageRequestAlisaMessagePostApiResponse,
        AlisaMessageRequestAlisaMessagePostApiArg
      >({
        query: (queryArg) => ({ url: `/alisa/message`, method: 'POST', body: queryArg.data }),
        invalidatesTags: ['agent'],
      }),
      createAgentBackupBackupAgentCreatePost: build.mutation<
        CreateAgentBackupBackupAgentCreatePostApiResponse,
        CreateAgentBackupBackupAgentCreatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/backup/agent/create`,
          method: 'POST',
          body: queryArg.bodyCreateAgentBackupBackupAgentCreatePost,
        }),
        invalidatesTags: ['backup'],
      }),
      createAgentBackupBackupAgentListGet: build.query<
        CreateAgentBackupBackupAgentListGetApiResponse,
        CreateAgentBackupBackupAgentListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/backup/agent/list`,
          params: {
            agent_id: queryArg.agentId,
          },
        }),
        providesTags: ['backup'],
      }),
      deleteAgentBackupBackupAgentDeleteDelete: build.mutation<
        DeleteAgentBackupBackupAgentDeleteDeleteApiResponse,
        DeleteAgentBackupBackupAgentDeleteDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/backup/agent/delete`,
          method: 'DELETE',
          params: {
            backup_id: queryArg.backupId,
          },
        }),
        invalidatesTags: ['backup'],
      }),
      agentBackupRestoreBackupAgentRestorePost: build.mutation<
        AgentBackupRestoreBackupAgentRestorePostApiResponse,
        AgentBackupRestoreBackupAgentRestorePostApiArg
      >({
        query: (queryArg) => ({
          url: `/backup/agent/restore`,
          method: 'POST',
          body: queryArg.bodyAgentBackupRestoreBackupAgentRestorePost,
        }),
        invalidatesTags: ['backup'],
      }),
      agentBackupChangeNameBackupAgentChangeNamePost: build.mutation<
        AgentBackupChangeNameBackupAgentChangeNamePostApiResponse,
        AgentBackupChangeNameBackupAgentChangeNamePostApiArg
      >({
        query: (queryArg) => ({
          url: `/backup/agent/change_name`,
          method: 'POST',
          body: queryArg.bodyAgentBackupChangeNameBackupAgentChangeNamePost,
          params: {
            backup_id: queryArg.backupId,
          },
        }),
        invalidatesTags: ['backup'],
      }),
      getWidgetSettingsListWidgetSettingsListGet: build.query<
        GetWidgetSettingsListWidgetSettingsListGetApiResponse,
        GetWidgetSettingsListWidgetSettingsListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/widget_settings/list`,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        providesTags: ['widget_settings'],
      }),
      getWidgetSettingsInfoWidgetSettingsInfoGet: build.query<
        GetWidgetSettingsInfoWidgetSettingsInfoGetApiResponse,
        GetWidgetSettingsInfoWidgetSettingsInfoGetApiArg
      >({
        query: (queryArg) => ({
          url: `/widget_settings/info`,
          params: {
            widget_settings_id: queryArg.widgetSettingsId,
          },
        }),
        providesTags: ['widget_settings'],
      }),
      createWidgetSettingsWidgetSettingsCreatePost: build.mutation<
        CreateWidgetSettingsWidgetSettingsCreatePostApiResponse,
        CreateWidgetSettingsWidgetSettingsCreatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/widget_settings/create`,
          method: 'POST',
          body: queryArg.baseWidgetSettings,
          params: {
            organization_id: queryArg.organizationId,
          },
        }),
        invalidatesTags: ['widget_settings'],
      }),
      updateWidgetSettingsWidgetSettingsUpdatePost: build.mutation<
        UpdateWidgetSettingsWidgetSettingsUpdatePostApiResponse,
        UpdateWidgetSettingsWidgetSettingsUpdatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/widget_settings/update`,
          method: 'POST',
          body: queryArg.baseWidgetSettings,
          params: {
            widget_settings_id: queryArg.widgetSettingsId,
          },
        }),
        invalidatesTags: ['widget_settings'],
      }),
      deleteWidgetSettingsWidgetSettingsDeleteDelete: build.mutation<
        DeleteWidgetSettingsWidgetSettingsDeleteDeleteApiResponse,
        DeleteWidgetSettingsWidgetSettingsDeleteDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/widget_settings/delete`,
          method: 'DELETE',
          params: {
            widget_settings_id: queryArg.widgetSettingsId,
          },
        }),
        invalidatesTags: ['widget_settings'],
      }),
      getDialogHistoryIframeHistoryGet: build.query<
        GetDialogHistoryIframeHistoryGetApiResponse,
        GetDialogHistoryIframeHistoryGetApiArg
      >({
        query: (queryArg) => ({
          url: `/iframe/history`,
          params: {
            client_uuid: queryArg.clientUuid,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ['iframe'],
      }),
      getClientFieldsIframeFieldsGet: build.query<
        GetClientFieldsIframeFieldsGetApiResponse,
        GetClientFieldsIframeFieldsGetApiArg
      >({
        query: (queryArg) => ({
          url: `/iframe/fields`,
          params: {
            client_uuid: queryArg.clientUuid,
          },
        }),
        providesTags: ['iframe'],
      }),
      iframeShowIframeShowClientUuidGet: build.query<
        IframeShowIframeShowClientUuidGetApiResponse,
        IframeShowIframeShowClientUuidGetApiArg
      >({
        query: (queryArg) => ({ url: `/iframe/show/${queryArg.clientUuid}` }),
        providesTags: ['iframe'],
      }),
      generatePreviewPreviewGeneratePost: build.mutation<
        GeneratePreviewPreviewGeneratePostApiResponse,
        GeneratePreviewPreviewGeneratePostApiArg
      >({
        query: (queryArg) => ({
          url: `/preview/generate`,
          method: 'POST',
          body: queryArg.previewGenerateData,
        }),
        invalidatesTags: ['preview'],
      }),
      getOrganizationPreviewPreviewListGet: build.query<
        GetOrganizationPreviewPreviewListGetApiResponse,
        GetOrganizationPreviewPreviewListGetApiArg
      >({
        query: (queryArg) => ({
          url: `/preview/list`,
          params: {
            organization_id: queryArg.organizationId,
            search: queryArg.search,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ['preview'],
      }),
      updatePreviewPreviewUpdatePost: build.mutation<
        UpdatePreviewPreviewUpdatePostApiResponse,
        UpdatePreviewPreviewUpdatePostApiArg
      >({
        query: (queryArg) => ({
          url: `/preview/update`,
          method: 'POST',
          body: queryArg.previewUpdateData,
          params: {
            preview_id: queryArg.previewId,
          },
        }),
        invalidatesTags: ['preview'],
      }),
      deletePreviewPreviewDeletePost: build.mutation<
        DeletePreviewPreviewDeletePostApiResponse,
        DeletePreviewPreviewDeletePostApiArg
      >({
        query: (queryArg) => ({
          url: `/preview/delete`,
          method: 'POST',
          params: {
            preview_id: queryArg.previewId,
          },
        }),
        invalidatesTags: ['preview'],
      }),
      serveAsyncapiSchemaAsyncapiGet: build.query<
        ServeAsyncapiSchemaAsyncapiGetApiResponse,
        ServeAsyncapiSchemaAsyncapiGetApiArg
      >({
        query: (queryArg) => ({
          url: `/asyncapi`,
          params: {
            sidebar: queryArg.sidebar,
            info: queryArg.info,
            servers: queryArg.servers,
            operations: queryArg.operations,
            messages: queryArg.messages,
            schemas: queryArg.schemas,
            errors: queryArg.errors,
            expandMessageExamples: queryArg.expandMessageExamples,
          },
        }),
        providesTags: ['asyncapi'],
      }),
      downloadAppJsonSchemaAsyncapiJsonGet: build.query<
        DownloadAppJsonSchemaAsyncapiJsonGetApiResponse,
        DownloadAppJsonSchemaAsyncapiJsonGetApiArg
      >({
        query: () => ({ url: `/asyncapi.json` }),
        providesTags: ['asyncapi'],
      }),
      downloadAppYamlSchemaAsyncapiYamlGet: build.query<
        DownloadAppYamlSchemaAsyncapiYamlGetApiResponse,
        DownloadAppYamlSchemaAsyncapiYamlGetApiArg
      >({
        query: () => ({ url: `/asyncapi.yaml` }),
        providesTags: ['asyncapi'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as generatedApi };
export type SendMessageWidgetMessagePostApiResponse = /** status 200 Successful Response */ any;
export type SendMessageWidgetMessagePostApiArg = {
  bodySendMessageWidgetMessagePost: BodySendMessageWidgetMessagePost;
};
export type GetChatHistoryWidgetChatHistoryGetApiResponse =
  /** status 200 Successful Response */ PaginatedListWidgetMessage;
export type GetChatHistoryWidgetChatHistoryGetApiArg = {
  limit?: number;
  offset?: number;
};
export type SendClientFieldsWidgetFieldsPostApiResponse = /** status 200 Successful Response */ any;
export type SendClientFieldsWidgetFieldsPostApiArg = {
  bodySendClientFieldsWidgetFieldsPost: BodySendClientFieldsWidgetFieldsPost;
};
export type SendClientFieldsByAliasWidgetFieldsByAliasPostApiResponse =
  /** status 200 Successful Response */ any;
export type SendClientFieldsByAliasWidgetFieldsByAliasPostApiArg = {
  bodySendClientFieldsByAliasWidgetFieldsByAliasPost: BodySendClientFieldsByAliasWidgetFieldsByAliasPost;
};
export type GetWidgetPreviewWidgetPreviewGetApiResponse =
  /** status 200 Successful Response */ WidgetPreviewData;
export type GetWidgetPreviewWidgetPreviewGetApiArg = {
  url: string;
};
export type GetWidgetScriptWidgetScriptJsGetApiResponse = /** status 200 Successful Response */ any;
export type GetWidgetScriptWidgetScriptJsGetApiArg = void;
export type GetWidgetSettingsWidgetSettingsGetApiResponse =
  /** status 200 Successful Response */ BaseWidgetSettings;
export type GetWidgetSettingsWidgetSettingsGetApiArg = void;
export type SendEventWidgetEventPostApiResponse = /** status 200 Successful Response */ any;
export type SendEventWidgetEventPostApiArg = {
  bodySendEventWidgetEventPost: BodySendEventWidgetEventPost;
};
export type AuthByTokenAuthProviderProviderTypePostApiResponse =
  /** status 200 Successful Response */ AuthTokenResponse;
export type AuthByTokenAuthProviderProviderTypePostApiArg = {
  providerType: AuthProvider;
  bodyAuthByTokenAuthProviderProviderTypePost: BodyAuthByTokenAuthProviderProviderTypePost;
};
export type RefreshTokenAuthTokenRefreshPostApiResponse =
  /** status 200 Successful Response */ AuthTokenResponse;
export type RefreshTokenAuthTokenRefreshPostApiArg = {
  bodyRefreshTokenAuthTokenRefreshPost: BodyRefreshTokenAuthTokenRefreshPost;
};
export type GetMeUserMeGetApiResponse = /** status 200 Successful Response */ UserInfo;
export type GetMeUserMeGetApiArg = void;
export type GetOrganizationListOrganizationListGetApiResponse =
  /** status 200 Successful Response */ OrganizationInfo[];
export type GetOrganizationListOrganizationListGetApiArg = void;
export type CreateOrganizationOrganizationCreatePostApiResponse =
  /** status 200 Successful Response */ OrganizationInfo;
export type CreateOrganizationOrganizationCreatePostApiArg = {
  createOrganization: CreateOrganization;
};
export type ChangeNameOrganizationOrganizationChangeNamePostApiResponse =
  /** status 200 Successful Response */ OrganizationInfo;
export type ChangeNameOrganizationOrganizationChangeNamePostApiArg = {
  bodyChangeNameOrganizationOrganizationChangeNamePost: BodyChangeNameOrganizationOrganizationChangeNamePost;
};
export type GetChannelListChannelListGetApiResponse =
  /** status 200 Successful Response */ ChannelInfoForList[];
export type GetChannelListChannelListGetApiArg = {
  organizationId: number;
  agentId?: number | null;
};
export type GetChannelInfoChannelInfoGetApiResponse =
  /** status 200 Successful Response */ ChannelInfo;
export type GetChannelInfoChannelInfoGetApiArg = {
  channelId: number;
};
export type CreateTelegramBotChannelChannelCreateTelegramBotPostApiResponse =
  /** status 200 Successful Response */ ChannelInfo;
export type CreateTelegramBotChannelChannelCreateTelegramBotPostApiArg = {
  organizationId: number;
  createTelegramBotChannel: CreateTelegramBotChannel;
};
export type CreateVkBotChannelChannelCreateVkBotPostApiResponse =
  /** status 200 Successful Response */ ChannelInfo;
export type CreateVkBotChannelChannelCreateVkBotPostApiArg = {
  organizationId: number;
  createVkBotChannel: CreateVkBotChannel;
};
export type CreateWidgetChannelChannelCreateWidgetPostApiResponse =
  /** status 200 Successful Response */ ChannelInfo;
export type CreateWidgetChannelChannelCreateWidgetPostApiArg = {
  organizationId: number;
  createWidgetChannel: CreateWidgetChannel;
};
export type CreateWidgetChannelChannelCreateAlisaPostApiResponse =
  /** status 200 Successful Response */ ChannelInfo;
export type CreateWidgetChannelChannelCreateAlisaPostApiArg = {
  organizationId: number;
  createAlisaChannel: CreateAlisaChannel;
};
export type CreateTelegramChannelChannelCreateTelegramPostApiResponse =
  /** status 200 Successful Response */ ChannelInfo;
export type CreateTelegramChannelChannelCreateTelegramPostApiArg = {
  organizationId: number;
  createChannel: CreateChannel;
};
export type CreateAvitoChannelChannelCreateAvitoPostApiResponse =
  /** status 200 Successful Response */ ChannelInfo;
export type CreateAvitoChannelChannelCreateAvitoPostApiArg = {
  organizationId: number;
  createAvitoChannel: CreateAvitoChannel;
};
export type CreateMaxBotChannelChannelCreateMaxBotPostApiResponse =
  /** status 200 Successful Response */ ChannelInfo;
export type CreateMaxBotChannelChannelCreateMaxBotPostApiArg = {
  organizationId: number;
  createMaxBotChannel: CreateMaxBotChannel;
};
export type UpdateChannelChannelUpdatePostApiResponse =
  /** status 200 Successful Response */ ChannelInfo;
export type UpdateChannelChannelUpdatePostApiArg = {
  channelId: number;
  updateChannel: UpdateChannel;
};
export type ChannelHealthCheckChannelHealthPostApiResponse =
  /** status 200 Successful Response */ ChannelHealthCheck;
export type ChannelHealthCheckChannelHealthPostApiArg = {
  channelId: number;
};
export type DeleteChannelChannelDeleteDeleteApiResponse = /** status 200 Successful Response */ any;
export type DeleteChannelChannelDeleteDeleteApiArg = {
  channelId: number;
};
export type GetTelegramQrLinkChannelTelegramQrLinkPostApiResponse =
  /** status 200 Successful Response */ string;
export type GetTelegramQrLinkChannelTelegramQrLinkPostApiArg = {
  channelId: number;
};
export type GetAgentInfoAgentInfoGetApiResponse = /** status 200 Successful Response */ AgentInfo;
export type GetAgentInfoAgentInfoGetApiArg = {
  agentId: number;
};
export type GetAgentListAgentListGetApiResponse =
  /** status 200 Successful Response */ AgentShortData[];
export type GetAgentListAgentListGetApiArg = {
  organizationId: number;
};
export type CreateAgentAgentCreatePostApiResponse = /** status 200 Successful Response */ AgentInfo;
export type CreateAgentAgentCreatePostApiArg = {
  organizationId: number;
  'x-language'?: string | null;
  createAgentData: CreateAgentData;
};
export type UpdateAgentAgentUpdatePostApiResponse = /** status 200 Successful Response */ AgentInfo;
export type UpdateAgentAgentUpdatePostApiArg = {
  agentId: number;
  updateAgentData: UpdateAgentData;
};
export type DeleteAgentAgentDeleteDeleteApiResponse = /** status 200 Successful Response */ any;
export type DeleteAgentAgentDeleteDeleteApiArg = {
  agentId: number;
};
export type AgentFieldAgentFieldGetApiResponse = /** status 200 Successful Response */ AgentField;
export type AgentFieldAgentFieldGetApiArg = {
  agentFieldId: number;
};
export type AgentFieldDeleteAgentFieldDeleteApiResponse = /** status 200 Successful Response */ any;
export type AgentFieldDeleteAgentFieldDeleteApiArg = {
  agentFieldId: number;
};
export type AgentFieldsListAgentFieldListGetApiResponse =
  /** status 200 Successful Response */ AgentField[];
export type AgentFieldsListAgentFieldListGetApiArg = {
  agentId: number;
};
export type AgentFieldCreateAgentFieldCreatePostApiResponse =
  /** status 200 Successful Response */ AgentField;
export type AgentFieldCreateAgentFieldCreatePostApiArg = {
  agentId: number;
  createAgentField: CreateAgentField;
};
export type AgentFieldUpdateAgentFieldUpdatePostApiResponse =
  /** status 200 Successful Response */ AgentField;
export type AgentFieldUpdateAgentFieldUpdatePostApiArg = {
  agentFieldId: number;
  updateAgentField: UpdateAgentField;
};
export type GetDialogHistoryDialogHistoryGetApiResponse =
  /** status 200 Successful Response */ PaginatedListClientMessageData;
export type GetDialogHistoryDialogHistoryGetApiArg = {
  clientId: number;
  limit?: number;
  offset?: number;
};
export type GetListDialogsDialogListPostApiResponse =
  /** status 200 Successful Response */ PaginatedListDialogShortData;
export type GetListDialogsDialogListPostApiArg = {
  limit?: number;
  offset?: number;
  dialogListFilters: DialogListFilters;
};
export type SendDialogMessageDialogSendPostApiResponse =
  /** status 200 Successful Response */ ClientMessageData;
export type SendDialogMessageDialogSendPostApiArg = {
  bodySendDialogMessageDialogSendPost: BodySendDialogMessageDialogSendPost;
};
export type AddManagerDeltaTimeDialogAddManagerDeltaTimePostApiResponse =
  /** status 200 Successful Response */ ClientMessageData;
export type AddManagerDeltaTimeDialogAddManagerDeltaTimePostApiArg = {
  bodyAddManagerDeltaTimeDialogAddManagerDeltaTimePost: BodyAddManagerDeltaTimeDialogAddManagerDeltaTimePost;
};
export type GetLastManagerMessageDialogGetLastManagerMessagePostApiResponse =
  /** status 200 Successful Response */ ClientMessageData;
export type GetLastManagerMessageDialogGetLastManagerMessagePostApiArg = {
  bodyGetLastManagerMessageDialogGetLastManagerMessagePost: BodyGetLastManagerMessageDialogGetLastManagerMessagePost;
};
export type GetClientFieldsClientFieldsGetApiResponse =
  /** status 200 Successful Response */ AgentClientFields[];
export type GetClientFieldsClientFieldsGetApiArg = {
  clientId: number;
};
export type UpdateClientFieldsClientFieldsUpdatePostApiResponse =
  /** status 200 Successful Response */ ClientFieldData;
export type UpdateClientFieldsClientFieldsUpdatePostApiArg = {
  updateClientFieldData: UpdateClientFieldData;
};
export type ResendLeadClientLeadResendPostApiResponse = /** status 200 Successful Response */ any;
export type ResendLeadClientLeadResendPostApiArg = {
  clientId: number;
};
export type UpdateClientTestClientUpdateTestPostApiResponse =
  /** status 200 Successful Response */ any;
export type UpdateClientTestClientUpdateTestPostApiArg = {
  updateClientTestData: UpdateClientTestData;
};
export type WebhookListIntegrationWebhookListGetApiResponse =
  /** status 200 Successful Response */ WebhookIntegrationShortData[];
export type WebhookListIntegrationWebhookListGetApiArg = {
  channelId: number;
};
export type WebhookInfoIntegrationWebhookInfoGetApiResponse =
  /** status 200 Successful Response */ WebhookIntegrationData;
export type WebhookInfoIntegrationWebhookInfoGetApiArg = {
  webhookIntegrationId: number;
};
export type WebhookCreateIntegrationWebhookCreatePostApiResponse =
  /** status 200 Successful Response */ WebhookIntegrationData;
export type WebhookCreateIntegrationWebhookCreatePostApiArg = {
  webhookIntegrationCreate: WebhookIntegrationCreate;
};
export type WebhookDeleteIntegrationWebhookDeleteDeleteApiResponse =
  /** status 200 Successful Response */ any;
export type WebhookDeleteIntegrationWebhookDeleteDeleteApiArg = {
  webhookIntegrationId: number;
};
export type WebhookUpdateIntegrationWebhookUpdatePostApiResponse =
  /** status 200 Successful Response */ WebhookIntegrationData;
export type WebhookUpdateIntegrationWebhookUpdatePostApiArg = {
  webhookIntegrationId: number;
  webhookIntegrationUpdate: WebhookIntegrationUpdate;
};
export type WebhookFieldCreateIntegrationWebhookFieldCreatePostApiResponse =
  /** status 200 Successful Response */ WebhookIntegrationData;
export type WebhookFieldCreateIntegrationWebhookFieldCreatePostApiArg = {
  webhookIntegrationId: number;
  webhookIntegrationFieldCreate: WebhookIntegrationFieldCreate;
};
export type WebhookFieldDeleteIntegrationWebhookFieldDeleteApiResponse =
  /** status 200 Successful Response */ WebhookIntegrationData;
export type WebhookFieldDeleteIntegrationWebhookFieldDeleteApiArg = {
  webhookIntegrationFieldId: number;
};
export type GetClientsStatsAnalyticsStatsClientsPostApiResponse =
  /** status 200 Successful Response */ AnalyticsIntervalData;
export type GetClientsStatsAnalyticsStatsClientsPostApiArg = {
  analyticsDialogsRequest: AnalyticsDialogsRequest;
};
export type GetMessagesStatsAnalyticsStatsMessagesPostApiResponse =
  /** status 200 Successful Response */ AnalyticsIntervalData;
export type GetMessagesStatsAnalyticsStatsMessagesPostApiArg = {
  analyticsDialogsRequest: AnalyticsDialogsRequest;
};
export type GetLeadsStatsAnalyticsStatsLeadsPostApiResponse =
  /** status 200 Successful Response */ AnalyticsIntervalData;
export type GetLeadsStatsAnalyticsStatsLeadsPostApiArg = {
  analyticsDialogsRequest: AnalyticsDialogsRequest;
};
export type GetDialogsStatsAnalyticsStatsDialogsPostApiResponse =
  /** status 200 Successful Response */ AnalyticsIntervalData;
export type GetDialogsStatsAnalyticsStatsDialogsPostApiArg = {
  analyticsDialogsRequest: AnalyticsDialogsRequest;
};
export type GetAllStatsAnalyticsStatsAllPostApiResponse =
  /** status 200 Successful Response */ AnalyticsAllStats;
export type GetAllStatsAnalyticsStatsAllPostApiArg = {
  analyticsDialogsRequest: AnalyticsDialogsRequest;
};
export type GetExpensesStatsAnalyticsStatsExpensesPostApiResponse =
  /** status 200 Successful Response */ AnalyticsExpensesStats;
export type GetExpensesStatsAnalyticsStatsExpensesPostApiArg = {
  analyticsDialogsRequest: AnalyticsDialogsRequest;
};
export type GetQuestionsStatsAnalyticsStatsQuestionsPostApiResponse =
  /** status 200 Successful Response */ AnalyticsTopic[];
export type GetQuestionsStatsAnalyticsStatsQuestionsPostApiArg = {
  analyticsDialogsRequest: AnalyticsDialogsRequest;
};
export type GetAllStatsWidgetAnalyticsWidgetStatsPostApiResponse =
  /** status 200 Successful Response */ AnalyticsWidgetStats;
export type GetAllStatsWidgetAnalyticsWidgetStatsPostApiArg = {
  analyticsWidgetStatsRequest: AnalyticsWidgetStatsRequest;
};
export type GetWidgetPagesAnalyticsWidgetPagesPostApiResponse =
  /** status 200 Successful Response */ AnalyticsWidgetPages;
export type GetWidgetPagesAnalyticsWidgetPagesPostApiArg = {
  analyticsWidgetPagesRequest: AnalyticsWidgetPagesRequest;
};
export type GetWidgetPageMessagesAnalyticsWidgetPagesMessagesPostApiResponse =
  /** status 200 Successful Response */ AnalyticsWidgetPageMessages;
export type GetWidgetPageMessagesAnalyticsWidgetPagesMessagesPostApiArg = {
  analyticsWidgetPageMessagesRequest: AnalyticsWidgetPageMessagesRequest;
};
export type GetWidgetChangesAnalyticsWidgetChangesPostApiResponse =
  /** status 200 Successful Response */ WidgetChangesTimeline;
export type GetWidgetChangesAnalyticsWidgetChangesPostApiArg = {
  widgetChangesRequest: WidgetChangesRequest;
};
export type GetWidgetChangesDetailsAnalyticsWidgetChangesDetailsPostApiResponse =
  /** status 200 Successful Response */ WidgetChangesDetails;
export type GetWidgetChangesDetailsAnalyticsWidgetChangesDetailsPostApiArg = {
  widgetChangesDetailsRequest: WidgetChangesDetailsRequest;
};
export type GetKnowledgeListKnowledgeListGetApiResponse =
  /** status 200 Successful Response */ KnowledgeBaseInfo[];
export type GetKnowledgeListKnowledgeListGetApiArg = {
  organizationId: number;
};
export type KnowledgeLinkAddKnowledgeLinkAddPostApiResponse =
  /** status 200 Successful Response */ KnowledgeBaseInfo;
export type KnowledgeLinkAddKnowledgeLinkAddPostApiArg = {
  bodyKnowledgeLinkAddKnowledgeLinkAddPost: BodyKnowledgeLinkAddKnowledgeLinkAddPost;
};
export type KnowledgeLinkRelatedKnowledgeLinkRelatedPostApiResponse =
  /** status 200 Successful Response */ RelatedLink[];
export type KnowledgeLinkRelatedKnowledgeLinkRelatedPostApiArg = {
  bodyKnowledgeLinkRelatedKnowledgeLinkRelatedPost: BodyKnowledgeLinkRelatedKnowledgeLinkRelatedPost;
};
export type KnowledgeFileUploadKnowledgeFileUploadPostApiResponse =
  /** status 200 Successful Response */ KnowledgeBaseInfo;
export type KnowledgeFileUploadKnowledgeFileUploadPostApiArg = {
  bodyKnowledgeFileUploadKnowledgeFileUploadPost: BodyKnowledgeFileUploadKnowledgeFileUploadPost;
};
export type KnowledgeFileDownloadKnowledgeFileDownloadGetApiResponse =
  /** status 200 Successful Response */ any;
export type KnowledgeFileDownloadKnowledgeFileDownloadGetApiArg = {
  knowledgeBaseId: number;
};
export type KnowledgeBaseDeleteKnowledgeRemoveDeleteApiResponse =
  /** status 200 Successful Response */ any;
export type KnowledgeBaseDeleteKnowledgeRemoveDeleteApiArg = {
  knowledgeBaseId: number;
};
export type KnowledgeBaseUpdateKnowledgeAgentUpdatePostApiResponse =
  /** status 200 Successful Response */ any;
export type KnowledgeBaseUpdateKnowledgeAgentUpdatePostApiArg = {
  bodyKnowledgeBaseUpdateKnowledgeAgentUpdatePost: BodyKnowledgeBaseUpdateKnowledgeAgentUpdatePost;
};
export type KnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPostApiResponse =
  /** status 200 Successful Response */ KnowledgeBaseInfo;
export type KnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPostApiArg = {
  bodyKnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPost: BodyKnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPost;
};
export type KnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePostApiResponse =
  /** status 200 Successful Response */ KnowledgeBaseInfo;
export type KnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePostApiArg = {
  bodyKnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePost: BodyKnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePost;
};
export type KnowledgeManualSyncKnowledgeLinkedDocumentSyncPostApiResponse =
  /** status 200 Successful Response */ KnowledgeBaseInfo;
export type KnowledgeManualSyncKnowledgeLinkedDocumentSyncPostApiArg = {
  bodyKnowledgeManualSyncKnowledgeLinkedDocumentSyncPost: BodyKnowledgeManualSyncKnowledgeLinkedDocumentSyncPost;
};
export type MembersListTeamListGetApiResponse =
  /** status 200 Successful Response */ TeamMemberInfo[];
export type MembersListTeamListGetApiArg = {
  organizationId: number;
};
export type UpdatePermissionTeamUpdatePermissionPostApiResponse =
  /** status 200 Successful Response */ any;
export type UpdatePermissionTeamUpdatePermissionPostApiArg = {
  bodyUpdatePermissionTeamUpdatePermissionPost: BodyUpdatePermissionTeamUpdatePermissionPost;
};
export type RemoveMemberTeamRemoveDeleteApiResponse = /** status 200 Successful Response */ any;
export type RemoveMemberTeamRemoveDeleteApiArg = {
  bodyRemoveMemberTeamRemoveDelete: BodyRemoveMemberTeamRemoveDelete;
};
export type CreateInviteLinkTeamCreateInviteLinkGetApiResponse =
  /** status 200 Successful Response */ string;
export type CreateInviteLinkTeamCreateInviteLinkGetApiArg = {
  organizationId: number;
  role?: PermissionEnum;
};
export type CreateInviteLinkTeamJoinPostApiResponse =
  /** status 200 Successful Response */ ShortOrganizationForUser;
export type CreateInviteLinkTeamJoinPostApiArg = {
  bodyCreateInviteLinkTeamJoinPost: BodyCreateInviteLinkTeamJoinPost;
};
export type GetTransactionsListCreditTransactionsListPostApiResponse =
  /** status 200 Successful Response */ PaginatedListCreditTransactionData;
export type GetTransactionsListCreditTransactionsListPostApiArg = {
  organizationId: number;
  limit?: number;
  offset?: number;
  transactionsListFilters: TransactionsListFilters;
};
export type GetMessageListAgentTestListGetApiResponse =
  /** status 200 Successful Response */ PaginatedListMessageAgentTestData;
export type GetMessageListAgentTestListGetApiArg = {
  agentId: number;
  limit?: number;
  offset?: number;
};
export type SendAgentMessageAgentTestMessagePostApiResponse =
  /** status 200 Successful Response */ MessageAgentTestData;
export type SendAgentMessageAgentTestMessagePostApiArg = {
  agentId: number;
  bodySendAgentMessageAgentTestMessagePost: BodySendAgentMessageAgentTestMessagePost;
};
export type ClearHistoryAgentTestClearHistoryPostApiResponse =
  /** status 200 Successful Response */ any;
export type ClearHistoryAgentTestClearHistoryPostApiArg = {
  agentId: number;
};
export type GetUserAgentFieldsAgentTestFieldsValuesGetApiResponse =
  /** status 200 Successful Response */ AgentTestClientFields[];
export type GetUserAgentFieldsAgentTestFieldsValuesGetApiArg = {
  agentId: number;
};
export type AlisaMessageRequestAlisaMessagePostApiResponse =
  /** status 200 Successful Response */ any;
export type AlisaMessageRequestAlisaMessagePostApiArg = {
  data: {
    [key: string]: any;
  };
};
export type CreateAgentBackupBackupAgentCreatePostApiResponse =
  /** status 200 Successful Response */ AgentBackupData;
export type CreateAgentBackupBackupAgentCreatePostApiArg = {
  bodyCreateAgentBackupBackupAgentCreatePost: BodyCreateAgentBackupBackupAgentCreatePost;
};
export type CreateAgentBackupBackupAgentListGetApiResponse =
  /** status 200 Successful Response */ AgentBackupData[];
export type CreateAgentBackupBackupAgentListGetApiArg = {
  agentId: number;
};
export type DeleteAgentBackupBackupAgentDeleteDeleteApiResponse =
  /** status 200 Successful Response */ any;
export type DeleteAgentBackupBackupAgentDeleteDeleteApiArg = {
  backupId: number;
};
export type AgentBackupRestoreBackupAgentRestorePostApiResponse =
  /** status 200 Successful Response */ any;
export type AgentBackupRestoreBackupAgentRestorePostApiArg = {
  bodyAgentBackupRestoreBackupAgentRestorePost: BodyAgentBackupRestoreBackupAgentRestorePost;
};
export type AgentBackupChangeNameBackupAgentChangeNamePostApiResponse =
  /** status 200 Successful Response */ any;
export type AgentBackupChangeNameBackupAgentChangeNamePostApiArg = {
  backupId: number;
  bodyAgentBackupChangeNameBackupAgentChangeNamePost: BodyAgentBackupChangeNameBackupAgentChangeNamePost;
};
export type GetWidgetSettingsListWidgetSettingsListGetApiResponse =
  /** status 200 Successful Response */ WidgetSettingsListItem[];
export type GetWidgetSettingsListWidgetSettingsListGetApiArg = {
  organizationId: number;
};
export type GetWidgetSettingsInfoWidgetSettingsInfoGetApiResponse =
  /** status 200 Successful Response */ WidgetSettings;
export type GetWidgetSettingsInfoWidgetSettingsInfoGetApiArg = {
  widgetSettingsId: number;
};
export type CreateWidgetSettingsWidgetSettingsCreatePostApiResponse =
  /** status 200 Successful Response */ WidgetSettings;
export type CreateWidgetSettingsWidgetSettingsCreatePostApiArg = {
  organizationId: number;
  baseWidgetSettings: BaseWidgetSettings;
};
export type UpdateWidgetSettingsWidgetSettingsUpdatePostApiResponse =
  /** status 200 Successful Response */ WidgetSettings;
export type UpdateWidgetSettingsWidgetSettingsUpdatePostApiArg = {
  widgetSettingsId: number;
  baseWidgetSettings: BaseWidgetSettings;
};
export type DeleteWidgetSettingsWidgetSettingsDeleteDeleteApiResponse =
  /** status 200 Successful Response */ any;
export type DeleteWidgetSettingsWidgetSettingsDeleteDeleteApiArg = {
  widgetSettingsId: number;
};
export type GetDialogHistoryIframeHistoryGetApiResponse =
  /** status 200 Successful Response */ PaginatedListClientMessageData;
export type GetDialogHistoryIframeHistoryGetApiArg = {
  clientUuid: string;
  limit?: number;
  offset?: number;
};
export type GetClientFieldsIframeFieldsGetApiResponse =
  /** status 200 Successful Response */ AgentClientFields[];
export type GetClientFieldsIframeFieldsGetApiArg = {
  clientUuid: string;
};
export type IframeShowIframeShowClientUuidGetApiResponse =
  /** status 200 Successful Response */ any;
export type IframeShowIframeShowClientUuidGetApiArg = {
  clientUuid: string;
};
export type GeneratePreviewPreviewGeneratePostApiResponse =
  /** status 200 Successful Response */ PreviewGenerationResponse;
export type GeneratePreviewPreviewGeneratePostApiArg = {
  previewGenerateData: PreviewGenerateData;
};
export type GetOrganizationPreviewPreviewListGetApiResponse =
  /** status 200 Successful Response */ PaginatedListPreviewInfo;
export type GetOrganizationPreviewPreviewListGetApiArg = {
  organizationId: number;
  search?: string | null;
  limit?: number;
  offset?: number;
};
export type UpdatePreviewPreviewUpdatePostApiResponse =
  /** status 200 Successful Response */ PreviewInfo;
export type UpdatePreviewPreviewUpdatePostApiArg = {
  previewId: number;
  previewUpdateData: PreviewUpdateData;
};
export type DeletePreviewPreviewDeletePostApiResponse = /** status 200 Successful Response */ any;
export type DeletePreviewPreviewDeletePostApiArg = {
  previewId: number;
};
export type ServeAsyncapiSchemaAsyncapiGetApiResponse = /** status 200 Successful Response */ any;
export type ServeAsyncapiSchemaAsyncapiGetApiArg = {
  sidebar?: boolean;
  info?: boolean;
  servers?: boolean;
  operations?: boolean;
  messages?: boolean;
  schemas?: boolean;
  errors?: boolean;
  expandMessageExamples?: boolean;
};
export type DownloadAppJsonSchemaAsyncapiJsonGetApiResponse =
  /** status 200 Successful Response */ any;
export type DownloadAppJsonSchemaAsyncapiJsonGetApiArg = void;
export type DownloadAppYamlSchemaAsyncapiYamlGetApiResponse =
  /** status 200 Successful Response */ any;
export type DownloadAppYamlSchemaAsyncapiYamlGetApiArg = void;
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type BodySendMessageWidgetMessagePost = {
  message: string;
  system_message?: string | null;
};
export type CreatorType = 'AI' | 'USER' | 'SYSTEM' | 'MANAGER';
export type WidgetMessage = {
  message_id: number;
  message: string;
  creator_type: CreatorType;
  created_at: string;
};
export type PaginatedListWidgetMessage = {
  offset: number;
  limit: number;
  count: number;
  items: WidgetMessage[];
};
export type WidgetClientField = {
  id: number;
  value: string;
};
export type BodySendClientFieldsWidgetFieldsPost = {
  fields: WidgetClientField[];
};
export type WidgetClientAliasField = {
  alias: string;
  value: string;
};
export type BodySendClientFieldsByAliasWidgetFieldsByAliasPost = {
  fields: WidgetClientAliasField[];
};
export type WidgetPreviewData = {
  question: string;
  answers: string[];
};
export type WidgetButtonThemeEnum = 'light' | 'dark' | 'custom';
export type WidgetIconTypeEnum = 'default' | 'custom';
export type WidgetIconConfig = {
  type: WidgetIconTypeEnum;
  custom_url?: string | null;
};
export type WidgetAppearance = {
  brand_color?: string | null;
  button_theme: WidgetButtonThemeEnum;
  button_background_color?: string | null;
  button_text_color?: string | null;
  widget_icon: WidgetIconConfig;
  font_family?: string | null;
};
export type WidgetContent = {
  button_text: string;
  assistant_name: string;
  welcome_message: string;
  quick_questions: string[];
};
export type WidgetPreviewModeEnum = 'dynamic' | 'static';
export type WidgetPreviewSection = {
  mode: WidgetPreviewModeEnum;
  show_delay_seconds: number;
  static_question?: string | null;
  static_answers: string[];
};
export type WidgetYandexMetrikaGoal = {
  event: string;
  goal_id: string;
};
export type WidgetYandexMetrika = {
  enabled: boolean;
  counter_id?: string | null;
  goals: WidgetYandexMetrikaGoal[];
};
export type WidgetAnalytics = {
  yandex_metrika: WidgetYandexMetrika;
};
export type WidgetContactFormModeEnum = 'by_messages' | 'by_events';
export type WidgetContactForm = {
  mode: WidgetContactFormModeEnum;
  message_before_form: string;
  show_after_messages: number;
  show_close_button?: boolean;
  trigger_events: string[];
  fields?: {
    [key: string]: any;
  }[];
  message_after_form?: string;
  show_form_after_answer?: boolean;
};
export type WidgetMessagesConfig = {
  border_radius: number;
  tail_enabled: boolean;
  show_agent_answer_hints: boolean;
};
export type WidgetSizeConfig = {
  width_px?: number;
  height_px?: number;
  border_width_px?: number;
  border_color?: string;
};
export type WidgetButtonConfig = {
  border_radius: number;
  width_px?: number;
  height_px?: number;
  border_width_px?: number;
  border_color?: string;
};
export type WidgetAdvancedPreview = {
  message_border_radius: number;
  hint_border_radius: number;
  show_agent_answer_hints: boolean;
};
export type WidgetPlacementEnum = 'bottom_right' | 'bottom_left';
export type WidgetPosition = {
  placement: WidgetPlacementEnum;
  side_offset: number;
  bottom_offset: number;
  unit?: 'px';
};
export type WidgetPositionPair = {
  desktop: WidgetPosition;
  mobile: WidgetPosition;
};
export type WidgetAdvanced = {
  contact_form: WidgetContactForm;
  messages: WidgetMessagesConfig;
  widget?: WidgetSizeConfig;
  button: WidgetButtonConfig;
  preview: WidgetAdvancedPreview;
  position: WidgetPositionPair;
};
export type BaseWidgetSettings = {
  name: string;
  description: string;
  personal_data_policy_url: string | null;
  appearance: WidgetAppearance;
  content: WidgetContent;
  preview: WidgetPreviewSection;
  analytics: WidgetAnalytics;
  advanced: WidgetAdvanced;
};
export type WidgetEventType =
  | 'WIDGET_SHOWN'
  | 'PREVIEW_OPEN'
  | 'CHAT_OPEN'
  | 'FIRST_MESSAGE_SENT'
  | 'AUTH_FORM_SHOWN'
  | 'AUTH_FORM_SUBMIT';
export type BodySendEventWidgetEventPost = {
  event_type: WidgetEventType;
  page_url: string;
};
export type PermissionEnum = 'OWNER' | 'ADMIN' | 'MANAGER';
export type ShortOrganizationForUser = {
  id: number;
  title: string;
  credit_balance: number;
  permission: PermissionEnum;
};
export type UserInfo = {
  id: number;
  full_name?: string | null;
  email?: string | null;
  phone?: string | null;
  organizations?: ShortOrganizationForUser[];
};
export type AuthTokenResponse = {
  user_info: UserInfo;
  access_token: string;
  refresh_token: string;
};
export type AuthProvider = 'yandex' | 'google';
export type BodyAuthByTokenAuthProviderProviderTypePost = {
  code: string;
};
export type BodyRefreshTokenAuthTokenRefreshPost = {
  token: string;
};
export type OrganizationInfo = {
  id: number;
  title: string;
  email: string | null;
  phone: string | null;
  created_at: string;
  credit_balance: number;
};
export type CreateOrganization = {
  title: string;
  email?: string | null;
  phone?: string | null;
};
export type BodyChangeNameOrganizationOrganizationChangeNamePost = {
  organization_id: number;
  new_name: string;
};
export type ChannelTypeEnum =
  | 'telegram_bot'
  | 'telegram'
  | 'widget'
  | 'vk_bot'
  | 'alisa'
  | 'max_bot'
  | 'avito';
export type ChannelInfoForList = {
  id: number;
  name: string;
  type: ChannelTypeEnum;
  is_active: boolean;
  agent_id: number;
  agent_name: string;
  description: string;
  created_at: string;
};
export type TgBotConfigInfo = {
  token: string;
  start_message: string;
};
export type VkBotConfigInfo = {
  token: string;
};
export type WidgetConfigInfo = {
  host: string;
  settings_id?: number | null;
};
export type MaxBotConfigInfo = {
  token: string;
  start_message: string;
};
export type AvitoConfigInfo = {
  client_id: string;
  client_secret: string;
};
export type ChannelInfo = {
  id: number;
  name: string;
  type: ChannelTypeEnum;
  is_active: boolean;
  agent_id: number;
  description: string;
  created_at: string;
  tg_bot_config?: TgBotConfigInfo | null;
  vk_bot_config?: VkBotConfigInfo | null;
  widget_config?: WidgetConfigInfo | null;
  max_bot_config?: MaxBotConfigInfo | null;
  avito_config?: AvitoConfigInfo | null;
};
export type CreateTelegramBotChannel = {
  name: string;
  agent_id: number;
  is_active: boolean;
  description?: string;
  token: string;
  start_message?: string;
};
export type CreateVkBotChannel = {
  name: string;
  agent_id: number;
  is_active: boolean;
  description?: string;
  token: string;
};
export type CreateWidgetChannel = {
  name: string;
  agent_id: number;
  is_active: boolean;
  description?: string;
  host: string;
  settings_id?: number | null;
};
export type CreateAlisaChannel = {
  name: string;
  agent_id: number;
  is_active: boolean;
  description?: string;
  yandex_user_id: string;
};
export type CreateChannel = {
  name: string;
  agent_id: number;
  is_active: boolean;
  description?: string;
};
export type CreateAvitoChannel = {
  name: string;
  agent_id: number;
  is_active: boolean;
  description?: string;
  client_id: string;
  client_secret: string;
};
export type CreateMaxBotChannel = {
  name: string;
  agent_id: number;
  is_active: boolean;
  description?: string;
  token: string;
  start_message?: string;
};
export type UpdateTelegramBotConfig = {
  token?: string | null;
  start_message?: string | null;
};
export type UpdateVkBotConfig = {
  token?: string | null;
};
export type UpdateWidgetConfig = {
  host?: string | null;
  settings_id?: number | null;
};
export type UpdateMaxBotConfig = {
  token?: string | null;
  start_message?: string | null;
};
export type UpdateAvitoConfig = {
  client_id?: string | null;
  client_secret?: string | null;
};
export type UpdateChannel = {
  name?: string | null;
  agent_id?: number | null;
  is_active?: boolean | null;
  description?: string | null;
  tg_bot_config?: UpdateTelegramBotConfig;
  vk_bot_config?: UpdateVkBotConfig;
  widget_config?: UpdateWidgetConfig;
  max_bot_config?: UpdateMaxBotConfig;
  avito_config?: UpdateAvitoConfig;
};
export type ChannelHealthCheck = {
  is_live: boolean;
  message: string;
};
export type AgentField = {
  id: number;
  name: string;
  description: string;
  filter: string[];
  is_required: boolean;
  is_default: boolean;
  is_active: boolean;
  use_knowledge_filter: boolean;
  alias: string | null;
};
export type AgentStage = {
  id: number;
  order: number;
  agent_field_id: number;
  prompt: string;
};
export type AgentLink = {
  id: number;
  prompt: string;
  target_agent_id: number;
};
export type AgentChargeMethodEnum = 'chat' | 'lead';
export type AgentInfo = {
  id: number;
  name: string;
  role: string;
  style: string;
  rules: string[];
  exceptions: string[];
  recommendations: string;
  show_form_prompts: string[];
  agent_fields: AgentField[];
  agent_stages: AgentStage[];
  agent_links: AgentLink[];
  agent_knowledge: number[];
  charge_method: AgentChargeMethodEnum;
};
export type AgentShortData = {
  id: number;
  name: string;
};
export type CreateAgentData = {
  name: string;
  role: string;
  style: string;
  rules: string[];
  exceptions: string[];
};
export type UpdateAgentStage = {
  order: number;
  agent_field_id: number;
  prompt: string;
};
export type UpdateAgentLink = {
  prompt: string;
  target_agent_id: number;
};
export type UpdateAgentData = {
  name?: string | null;
  role?: string | null;
  style?: string | null;
  rules?: string[] | null;
  exceptions?: string[] | null;
  stages?: UpdateAgentStage[] | null;
  charge_method?: AgentChargeMethodEnum | null;
  agent_links?: UpdateAgentLink[] | null;
  recommendations?: string | null;
  show_form_prompts?: string[] | null;
};
export type CreateAgentField = {
  name: string;
  description: string;
  filter: string[];
  is_required: boolean;
  is_active: boolean;
  alias?: string | null;
};
export type UpdateAgentField = {
  name?: string | null;
  description?: string | null;
  filter?: string[] | null;
  is_required?: boolean | null;
  is_active?: boolean | null;
  use_knowledge_filter?: boolean | null;
  alias?: string | null;
};
export type ClientMessageData = {
  id: number;
  creator_type: CreatorType;
  message: string;
  created_at: string;
  manager_delta?: number;
  switched_agent_id?: number | null;
  is_form_shown: boolean;
};
export type PaginatedListClientMessageData = {
  offset: number;
  limit: number;
  count: number;
  items: ClientMessageData[];
};
export type DialogShortData = {
  client_id: number;
  client_name: string | null;
  channel_type: ChannelTypeEnum;
  channel_id: number;
  last_message: string;
  last_message_at: string;
  client_avatar_url: string | null;
  lead_created_at: string | null;
  client_uuid: string;
  channel_value: string;
  is_test: boolean;
  is_online?: boolean;
};
export type PaginatedListDialogShortData = {
  offset: number;
  limit: number;
  count: number;
  items: DialogShortData[];
};
export type DialogListFilters = {
  organization_id: number;
  channel_ids?: number[] | null;
  is_lead?: boolean | null;
};
export type BodySendDialogMessageDialogSendPost = {
  client_id: number;
  message: string;
};
export type BodyAddManagerDeltaTimeDialogAddManagerDeltaTimePost = {
  message_id: number;
  seconds: number;
};
export type BodyGetLastManagerMessageDialogGetLastManagerMessagePost = {
  client_id: number;
};
export type ClientFieldData = {
  agent_field_id: number;
  agent_field_name: string;
  value: string;
};
export type AgentClientFields = {
  agent_id: number;
  agent_name: string;
  current_agent: boolean;
  client_fields: ClientFieldData[];
};
export type UpdateClientFieldData = {
  client_id: number;
  agent_field_id: number;
  value: string;
};
export type UpdateClientTestData = {
  client_id: number;
  is_test: boolean;
};
export type WebhookMethodType = 'GET' | 'POST';
export type WebhookIntegrationShortData = {
  id: number;
  title: string;
  channel_id: number;
  callback_url: string;
  method: WebhookMethodType;
};
export type LocationType = 'query' | 'body' | 'header';
export type WebhookIntegrationField = {
  id: number;
  location: LocationType;
  parameter_name: string;
  agent_field_id: number | null;
  value: string | null;
};
export type WebhookIntegrationData = {
  id: number;
  title: string;
  channel_id: number;
  callback_url: string;
  method: WebhookMethodType;
  fields: WebhookIntegrationField[];
};
export type WebhookIntegrationCreate = {
  title: string;
  channel_id: number;
  callback_url: string;
  method?: WebhookMethodType;
};
export type WebhookIntegrationUpdate = {
  title?: string | null;
  callback_url?: string | null;
  method?: WebhookMethodType | null;
};
export type WebhookIntegrationFieldCreate = {
  location: LocationType;
  parameter_name: string;
  agent_field_id: number | null;
  value: string | null;
};
export type IntervalData = {
  date: string;
  value: number;
};
export type AnalyticsIntervalData = {
  total_count: number;
  intervals: IntervalData[];
};
export type IntervalEnum = 'day' | 'hour';
export type AnalyticsDialogsRequest = {
  organization_id: number;
  channel_ids?: number[] | null;
  agent_ids?: number[] | null;
  date_from: string;
  date_to: string;
  interval: IntervalEnum;
};
export type AnalyticsAllStats = {
  client_count: number;
  lead_count: number;
  message_count: number;
  dialog_count: number;
};
export type AnalyticsChannelExpense = {
  channel_id: number;
  channel_name: string;
  expense: number;
};
export type AnalyticsDailyExpenses = {
  date: string;
  channels: AnalyticsChannelExpense[];
};
export type AnalyticsExpensesStats = {
  total_expenses: number;
  days: AnalyticsDailyExpenses[];
};
export type AnalyticsQuestion = {
  question: string;
  count: number;
};
export type AnalyticsTopic = {
  topic: string;
  questions: AnalyticsQuestion[];
};
export type FunnelItem = {
  event_type: WidgetEventType;
  value: number;
  conversion_from_previous: number;
  conversion_from_shown: number;
};
export type FunnelWidgetAnalytics = {
  items: FunnelItem[];
};
export type WidgetAnalyticsPoint = {
  date: string;
  value: number;
};
export type DynamicsWidgetAnalyticsSeries = {
  event_type: WidgetEventType;
  points: WidgetAnalyticsPoint[];
};
export type DynamicsWidgetAnalytics = {
  interval: IntervalEnum;
  series: DynamicsWidgetAnalyticsSeries[];
};
export type AnalyticsWidgetStats = {
  funnel: FunnelWidgetAnalytics;
  dynamics: DynamicsWidgetAnalytics;
};
export type AnalyticsWidgetStatsRequest = {
  organization_id: number;
  channel_ids?: number[] | null;
  agent_ids?: number[] | null;
  date_from: string;
  date_to: string;
  interval: IntervalEnum;
  /** OR-combined host/path glob patterns, for example `example.com` or `example.com/courses/*`. */
  page_url_patterns?: string[] | null;
};
export type WidgetPagesTotals = {
  pages: number;
  visitors: number;
  preview_shown: number;
  chat_open: number;
  first_message: number;
  leads: number;
  chat_rate: number;
  message_rate: number;
  lead_rate: number;
  potential_leads: number;
};
export type WidgetPageBenchmarkLevel = 'segment' | 'host' | 'all';
export type WidgetPagePeriodStats = {
  visitors: number;
  chat_rate: number;
  lead_rate: number;
};
export type WidgetPagePreview = {
  id: number;
  url: string;
  question: string;
  answers: string[];
  created_at: string;
  updated_at: string;
};
export type WidgetPageStats = {
  page_host: string;
  page_path: string;
  url: string;
  segment: string;
  /** Unique visitors who saw the widget on the page */
  visitors: number;
  views: number;
  preview_shown: number;
  chat_open: number;
  first_message: number;
  /** Visitors who sent their first message here and became leads */
  leads: number;
  /** Percent of visitors who opened the chat */
  chat_rate: number;
  message_rate: number;
  lead_rate: number;
  /** Median lead rate of comparable pages, percent */
  benchmark_lead_rate: number | null;
  benchmark_level: WidgetPageBenchmarkLevel | null;
  /** Extra leads if the page converted like its benchmark */
  potential_leads: number;
  low_data: boolean;
  /** Same page in the previous period of equal length */
  previous: WidgetPagePeriodStats | null;
  preview?: WidgetPagePreview | null;
};
export type WidgetPageSegment = {
  segment: string;
  host: string;
  pages: number;
  benchmark_pages: number;
  visitors: number;
  leads: number;
  median_lead_rate: number | null;
  median_chat_rate: number | null;
};
export type WidgetPageHost = {
  host: string;
  pages: number;
  visitors: number;
  leads: number;
};
export type WidgetPreviewModeSummary = 'dynamic' | 'static' | 'mixed';
export type AnalyticsWidgetPages = {
  /** Pages matching the filters, for pagination */
  total_pages: number;
  /** Pages below this many visitors are flagged as low data */
  low_data_visitors: number;
  /** False when the data does not cover the whole previous period, so trends are hidden */
  previous_period_available?: boolean;
  totals: WidgetPagesTotals;
  items: WidgetPageStats[];
  segments: WidgetPageSegment[];
  hosts: WidgetPageHost[];
  preview_mode?: WidgetPreviewModeSummary | null;
};
export type WidgetPagesSortField =
  | 'page'
  | 'visitors'
  | 'views'
  | 'preview_shown'
  | 'chat_open'
  | 'chat_rate'
  | 'first_message'
  | 'message_rate'
  | 'leads'
  | 'lead_rate'
  | 'potential_leads';
export type AnalyticsWidgetPagesRequest = {
  /** Only pages on these hosts; the hosts summary in the response ignores this filter. */
  hosts?: string[] | null;
  /** Hide pages with fewer unique visitors. */
  min_visitors?: number;
  search?: string | null;
  sort_by?: WidgetPagesSortField;
  sort_desc?: boolean;
  limit?: number;
  offset?: number;
  organization_id: number;
  channel_ids?: number[] | null;
  agent_ids?: number[] | null;
  date_from: string;
  date_to: string;
  interval: IntervalEnum;
  /** OR-combined host/path glob patterns, for example `example.com` or `example.com/courses/*`. */
  page_url_patterns?: string[] | null;
};
export type WidgetPageMessage = {
  message: string;
  visitors: number;
};
export type AnalyticsWidgetPageMessages = {
  page_host: string;
  page_path: string;
  items: WidgetPageMessage[];
};
export type AnalyticsWidgetPageMessagesRequest = {
  page_host: string;
  page_path?: string;
  limit?: number;
  organization_id: number;
  channel_ids?: number[] | null;
  agent_ids?: number[] | null;
  date_from: string;
  date_to: string;
  interval: IntervalEnum;
  /** OR-combined host/path glob patterns, for example `example.com` or `example.com/courses/*`. */
  page_url_patterns?: string[] | null;
};
export type WidgetChange = {
  id: number;
  change_group: string;
  agent_id: number | null;
  widget_settings_id: number | null;
  actor_id: number;
  entity_type: string;
  entity_id: number | null;
  property_name: string;
  action: string;
  position: number | null;
  old_value: any | null;
  new_value: any | null;
  created_at: string;
  subject_name?: string | null;
  entity_name?: string | null;
  actor_name?: string | null;
  old_value_name?: string | null;
  new_value_name?: string | null;
};
export type WidgetChangeBucket = {
  date: string;
  /** Number of distinct change_group saves in this interval */
  change_count: number;
  latest: WidgetChange[];
};
export type WidgetChangesTimeline = {
  interval: IntervalEnum;
  buckets: WidgetChangeBucket[];
};
export type WidgetChangesRequest = {
  organization_id: number;
  channel_ids?: number[] | null;
  agent_ids?: number[] | null;
  date_from: string;
  date_to: string;
  interval: IntervalEnum;
};
export type WidgetChangesDetails = {
  date: string;
  /** Number of property events, used for pagination */
  total_count: number;
  /** Number of distinct change_group saves */
  group_count?: number;
  changes: WidgetChange[];
};
export type WidgetChangesDetailsRequest = {
  organization_id: number;
  channel_ids?: number[] | null;
  agent_ids?: number[] | null;
  date_from: string;
  date_to: string;
  interval: IntervalEnum;
  bucket_start: string;
  limit?: number;
  offset?: number;
};
export type KnowledgeDataType = 'link' | 'file' | 'text' | 'linked_document';
export type UploadFileStatusEnum = 'LOADING' | 'LOADED' | 'ERROR';
export type KnowledgeSyncTimeEnum =
  | 'DISABLE'
  | 'EVERY_4_HOURS'
  | 'EVERY_12_HOURS'
  | 'EVERY_DAY'
  | 'EVERY_3_DAYS'
  | 'EVERY_WEEK'
  | 'EVERY_MONTH';
export type KnowledgeBaseInfo = {
  id: number;
  data_type: KnowledgeDataType;
  title: string;
  description: string;
  link: string | null;
  created_at: string;
  status: UploadFileStatusEnum;
  last_sync_at: string;
  sync_period: KnowledgeSyncTimeEnum;
};
export type BodyKnowledgeLinkAddKnowledgeLinkAddPost = {
  url: string;
  organization_id: number;
  title: string;
  description: string;
};
export type RelatedLink = {
  title: string;
  link: string;
};
export type BodyKnowledgeLinkRelatedKnowledgeLinkRelatedPost = {
  url: string;
};
export type BodyKnowledgeFileUploadKnowledgeFileUploadPost = {
  title: string;
  organization_id: number;
  description: string;
  uploaded_file: Blob;
};
export type BodyKnowledgeBaseUpdateKnowledgeAgentUpdatePost = {
  agent_id: number;
  knowledge_base_files: number[];
};
export type BodyKnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPost = {
  url: string;
  organization_id: number;
  title: string;
  description: string;
};
export type BodyKnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePost = {
  knowledge_base_id: number;
  sync_period: KnowledgeSyncTimeEnum;
};
export type BodyKnowledgeManualSyncKnowledgeLinkedDocumentSyncPost = {
  knowledge_base_id: number;
};
export type ShortUserInfo = {
  id: number;
  full_name?: string | null;
  email?: string | null;
  phone?: string | null;
};
export type TeamMemberInfo = {
  user_info: ShortUserInfo;
  permission: PermissionEnum;
  joined_at: string;
};
export type BodyUpdatePermissionTeamUpdatePermissionPost = {
  user_id: number;
  organization_id: number;
  permission: PermissionEnum;
};
export type BodyRemoveMemberTeamRemoveDelete = {
  user_id: number;
  organization_id: number;
};
export type BodyCreateInviteLinkTeamJoinPost = {
  code: string;
};
export type LedgerType = 'purchase' | 'manual_topup' | 'chat_charge' | 'lead_charge' | 'bonus';
export type CreditTransactionData = {
  id: number;
  amount: number;
  type: LedgerType;
  created_at: string;
  comment: string;
};
export type PaginatedListCreditTransactionData = {
  offset: number;
  limit: number;
  count: number;
  items: CreditTransactionData[];
};
export type TransactionsListFilters = {
  date_from: string;
  date_to: string;
  types?: LedgerType[];
};
export type MessageAgentTestData = {
  id: number;
  creator_type: CreatorType;
  message: string;
  created_at: string;
  recommendations: string[];
  switched_agent_id?: number | null;
  is_form_shown: boolean;
};
export type PaginatedListMessageAgentTestData = {
  offset: number;
  limit: number;
  count: number;
  items: MessageAgentTestData[];
};
export type BodySendAgentMessageAgentTestMessagePost = {
  message: string;
};
export type ClientTestFieldData = {
  agent_field_id: number;
  agent_field_name: string;
  is_required: boolean;
  value: string;
};
export type AgentTestClientFields = {
  agent_id: number;
  agent_name: string;
  current_agent: boolean;
  client_fields: ClientTestFieldData[];
};
export type AgentBackupData = {
  id: number;
  name: string;
  owner_name: string;
  created_at: string;
};
export type BodyCreateAgentBackupBackupAgentCreatePost = {
  agent_id: number;
  name: string;
};
export type BodyAgentBackupRestoreBackupAgentRestorePost = {
  backup_id: number;
};
export type BodyAgentBackupChangeNameBackupAgentChangeNamePost = {
  new_name: string;
};
export type WidgetSettingsListItem = {
  id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
};
export type WidgetSettings = {
  name: string;
  description: string;
  personal_data_policy_url: string | null;
  appearance: WidgetAppearance;
  content: WidgetContent;
  preview: WidgetPreviewSection;
  analytics: WidgetAnalytics;
  advanced: WidgetAdvanced;
  id: number;
  created_at: string;
  updated_at: string;
};
export type PreviewGenerationStatus = 'generating' | 'exists';
export type PreviewGenerationResponse = {
  status: PreviewGenerationStatus;
};
export type PreviewGenerateData = {
  organization_id: number;
  url: string;
};
export type PreviewInfo = {
  id: number;
  url: string;
  question: string;
  answers: string[];
};
export type PaginatedListPreviewInfo = {
  offset: number;
  limit: number;
  count: number;
  items: PreviewInfo[];
};
export type PreviewUpdateData = {
  question: string;
  answers: string[];
};
export const {
  useSendMessageWidgetMessagePostMutation,
  useGetChatHistoryWidgetChatHistoryGetQuery,
  useLazyGetChatHistoryWidgetChatHistoryGetQuery,
  useSendClientFieldsWidgetFieldsPostMutation,
  useSendClientFieldsByAliasWidgetFieldsByAliasPostMutation,
  useGetWidgetPreviewWidgetPreviewGetQuery,
  useLazyGetWidgetPreviewWidgetPreviewGetQuery,
  useGetWidgetScriptWidgetScriptJsGetQuery,
  useLazyGetWidgetScriptWidgetScriptJsGetQuery,
  useGetWidgetSettingsWidgetSettingsGetQuery,
  useLazyGetWidgetSettingsWidgetSettingsGetQuery,
  useSendEventWidgetEventPostMutation,
  useAuthByTokenAuthProviderProviderTypePostMutation,
  useRefreshTokenAuthTokenRefreshPostMutation,
  useGetMeUserMeGetQuery,
  useLazyGetMeUserMeGetQuery,
  useGetOrganizationListOrganizationListGetQuery,
  useLazyGetOrganizationListOrganizationListGetQuery,
  useCreateOrganizationOrganizationCreatePostMutation,
  useChangeNameOrganizationOrganizationChangeNamePostMutation,
  useGetChannelListChannelListGetQuery,
  useLazyGetChannelListChannelListGetQuery,
  useGetChannelInfoChannelInfoGetQuery,
  useLazyGetChannelInfoChannelInfoGetQuery,
  useCreateTelegramBotChannelChannelCreateTelegramBotPostMutation,
  useCreateVkBotChannelChannelCreateVkBotPostMutation,
  useCreateWidgetChannelChannelCreateWidgetPostMutation,
  useCreateWidgetChannelChannelCreateAlisaPostMutation,
  useCreateTelegramChannelChannelCreateTelegramPostMutation,
  useCreateAvitoChannelChannelCreateAvitoPostMutation,
  useCreateMaxBotChannelChannelCreateMaxBotPostMutation,
  useUpdateChannelChannelUpdatePostMutation,
  useChannelHealthCheckChannelHealthPostMutation,
  useDeleteChannelChannelDeleteDeleteMutation,
  useGetTelegramQrLinkChannelTelegramQrLinkPostMutation,
  useGetAgentInfoAgentInfoGetQuery,
  useLazyGetAgentInfoAgentInfoGetQuery,
  useGetAgentListAgentListGetQuery,
  useLazyGetAgentListAgentListGetQuery,
  useCreateAgentAgentCreatePostMutation,
  useUpdateAgentAgentUpdatePostMutation,
  useDeleteAgentAgentDeleteDeleteMutation,
  useAgentFieldAgentFieldGetQuery,
  useLazyAgentFieldAgentFieldGetQuery,
  useAgentFieldDeleteAgentFieldDeleteMutation,
  useAgentFieldsListAgentFieldListGetQuery,
  useLazyAgentFieldsListAgentFieldListGetQuery,
  useAgentFieldCreateAgentFieldCreatePostMutation,
  useAgentFieldUpdateAgentFieldUpdatePostMutation,
  useGetDialogHistoryDialogHistoryGetQuery,
  useLazyGetDialogHistoryDialogHistoryGetQuery,
  useGetListDialogsDialogListPostMutation,
  useSendDialogMessageDialogSendPostMutation,
  useAddManagerDeltaTimeDialogAddManagerDeltaTimePostMutation,
  useGetLastManagerMessageDialogGetLastManagerMessagePostMutation,
  useGetClientFieldsClientFieldsGetQuery,
  useLazyGetClientFieldsClientFieldsGetQuery,
  useUpdateClientFieldsClientFieldsUpdatePostMutation,
  useResendLeadClientLeadResendPostMutation,
  useUpdateClientTestClientUpdateTestPostMutation,
  useWebhookListIntegrationWebhookListGetQuery,
  useLazyWebhookListIntegrationWebhookListGetQuery,
  useWebhookInfoIntegrationWebhookInfoGetQuery,
  useLazyWebhookInfoIntegrationWebhookInfoGetQuery,
  useWebhookCreateIntegrationWebhookCreatePostMutation,
  useWebhookDeleteIntegrationWebhookDeleteDeleteMutation,
  useWebhookUpdateIntegrationWebhookUpdatePostMutation,
  useWebhookFieldCreateIntegrationWebhookFieldCreatePostMutation,
  useWebhookFieldDeleteIntegrationWebhookFieldDeleteMutation,
  useGetClientsStatsAnalyticsStatsClientsPostMutation,
  useGetMessagesStatsAnalyticsStatsMessagesPostMutation,
  useGetLeadsStatsAnalyticsStatsLeadsPostMutation,
  useGetDialogsStatsAnalyticsStatsDialogsPostMutation,
  useGetAllStatsAnalyticsStatsAllPostMutation,
  useGetExpensesStatsAnalyticsStatsExpensesPostMutation,
  useGetQuestionsStatsAnalyticsStatsQuestionsPostMutation,
  useGetAllStatsWidgetAnalyticsWidgetStatsPostMutation,
  useGetWidgetPagesAnalyticsWidgetPagesPostMutation,
  useGetWidgetPageMessagesAnalyticsWidgetPagesMessagesPostMutation,
  useGetWidgetChangesAnalyticsWidgetChangesPostMutation,
  useGetWidgetChangesDetailsAnalyticsWidgetChangesDetailsPostMutation,
  useGetKnowledgeListKnowledgeListGetQuery,
  useLazyGetKnowledgeListKnowledgeListGetQuery,
  useKnowledgeLinkAddKnowledgeLinkAddPostMutation,
  useKnowledgeLinkRelatedKnowledgeLinkRelatedPostMutation,
  useKnowledgeFileUploadKnowledgeFileUploadPostMutation,
  useKnowledgeFileDownloadKnowledgeFileDownloadGetQuery,
  useLazyKnowledgeFileDownloadKnowledgeFileDownloadGetQuery,
  useKnowledgeBaseDeleteKnowledgeRemoveDeleteMutation,
  useKnowledgeBaseUpdateKnowledgeAgentUpdatePostMutation,
  useKnowledgeLinkedDocumentUploadKnowledgeLinkedDocumentUploadPostMutation,
  useKnowledgeSyncPeriodUpdateKnowledgeSyncPeriodUpdatePostMutation,
  useKnowledgeManualSyncKnowledgeLinkedDocumentSyncPostMutation,
  useMembersListTeamListGetQuery,
  useLazyMembersListTeamListGetQuery,
  useUpdatePermissionTeamUpdatePermissionPostMutation,
  useRemoveMemberTeamRemoveDeleteMutation,
  useCreateInviteLinkTeamCreateInviteLinkGetQuery,
  useLazyCreateInviteLinkTeamCreateInviteLinkGetQuery,
  useCreateInviteLinkTeamJoinPostMutation,
  useGetTransactionsListCreditTransactionsListPostMutation,
  useGetMessageListAgentTestListGetQuery,
  useLazyGetMessageListAgentTestListGetQuery,
  useSendAgentMessageAgentTestMessagePostMutation,
  useClearHistoryAgentTestClearHistoryPostMutation,
  useGetUserAgentFieldsAgentTestFieldsValuesGetQuery,
  useLazyGetUserAgentFieldsAgentTestFieldsValuesGetQuery,
  useAlisaMessageRequestAlisaMessagePostMutation,
  useCreateAgentBackupBackupAgentCreatePostMutation,
  useCreateAgentBackupBackupAgentListGetQuery,
  useLazyCreateAgentBackupBackupAgentListGetQuery,
  useDeleteAgentBackupBackupAgentDeleteDeleteMutation,
  useAgentBackupRestoreBackupAgentRestorePostMutation,
  useAgentBackupChangeNameBackupAgentChangeNamePostMutation,
  useGetWidgetSettingsListWidgetSettingsListGetQuery,
  useLazyGetWidgetSettingsListWidgetSettingsListGetQuery,
  useGetWidgetSettingsInfoWidgetSettingsInfoGetQuery,
  useLazyGetWidgetSettingsInfoWidgetSettingsInfoGetQuery,
  useCreateWidgetSettingsWidgetSettingsCreatePostMutation,
  useUpdateWidgetSettingsWidgetSettingsUpdatePostMutation,
  useDeleteWidgetSettingsWidgetSettingsDeleteDeleteMutation,
  useGetDialogHistoryIframeHistoryGetQuery,
  useLazyGetDialogHistoryIframeHistoryGetQuery,
  useGetClientFieldsIframeFieldsGetQuery,
  useLazyGetClientFieldsIframeFieldsGetQuery,
  useIframeShowIframeShowClientUuidGetQuery,
  useLazyIframeShowIframeShowClientUuidGetQuery,
  useGeneratePreviewPreviewGeneratePostMutation,
  useGetOrganizationPreviewPreviewListGetQuery,
  useLazyGetOrganizationPreviewPreviewListGetQuery,
  useUpdatePreviewPreviewUpdatePostMutation,
  useDeletePreviewPreviewDeletePostMutation,
  useServeAsyncapiSchemaAsyncapiGetQuery,
  useLazyServeAsyncapiSchemaAsyncapiGetQuery,
  useDownloadAppJsonSchemaAsyncapiJsonGetQuery,
  useLazyDownloadAppJsonSchemaAsyncapiJsonGetQuery,
  useDownloadAppYamlSchemaAsyncapiYamlGetQuery,
  useLazyDownloadAppYamlSchemaAsyncapiYamlGetQuery,
} = injectedRtkApi;
